import { useUserGeneralProfile } from "@jugl-web/domain-resources/users/hooks/useUserGeneralProfile";
import { UserRole } from "@jugl-web/rest-api";
import useEntity from "@web-src/features/app/hooks/useEntity";
import { selectAuthDataState } from "@web-src/features/auth/authSlice";
import { useSelector } from "react-redux";

export const useMe = () => {
  const { entity } = useEntity();
  const authData = useSelector(selectAuthDataState);
  const meJid = authData?.data?.jid;
  const { profile, isLoading } = useUserGeneralProfile({
    // TODO: make sure we don't use it outside entity context
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    entityId: entity?.id,
    userId: meJid,
  });

  const isAdmin = profile?.role === UserRole.admin;

  return {
    id: meJid,
    me: profile?._user,
    isLoading,
    profile,
    isAdmin,
  };
};

export const useLoadedMe = () => {
  const { me, id, isAdmin } = useMe();

  if (!me || !id) {
    throw new Error("Me is not loaded yet");
  }
  return { me, meId: id, isAdmin };
};
